import { render } from "./TwLogoCases.vue?vue&type=template&id=9c3e97d2"
import script from "./TwLogoCases.vue?vue&type=script&lang=js"
export * from "./TwLogoCases.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__